var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/react-dnd/~/lodash/_Symbol.js
// module id = 366
// module chunks = 0